<template>
  <transition-group name="questionSlide" tag="div">

    <v-row key="back" class="back-button justify-space-between align-center flex mb-5" v-if="showStep > 1 && showStep < 4">
      <v-col xs="8" sm="10">
        <v-btn @click.prevent="gotoPrevStep">
            <v-icon  medium >mdi-arrow-left</v-icon>
          &nbsp; Back
          </v-btn>
      </v-col>

      <v-col xs="4" sm="2" class="Services__loader">
          <v-progress-linear value="33"></v-progress-linear>
      </v-col>

    </v-row>
    <div key="register" v-if="showStep == 1">
      <div class="registerForm">
        <v-row no-gutters>
          <v-col cols="12" sm="6" class="registerForm__left">
              <ul class="registerForm__list">
                <li class="">
                  <h3>Sign Up</h3>
                  <!-- <p>log in to your account or sign up.</p> -->
                  <router-link v-if="!isLoggedIn" :to="{ path: '/LoginSignupPage', query: { return_to: $route.path }}" query tag="button" class="v-btn v-btn--contained theme--light v-size--default">
                    login/ sign up
                  </router-link>
                  <div v-else>
                    <strong>Logged In</strong><br>
                  </div>
                </li>
                <li class="">
                  <h3>Fill the Application Form </h3>
                  <!-- <p>Fill the form... </p> -->
                  <span v-if="isLoggedIn">
                    <v-btn @click.prevent="showNextStep">Start</v-btn>
                  </span>
                </li>
                <li v-if="makePlansServiceID">
                  <h3>Scheduling </h3>
                  <!-- <p>when we'll do it</p> -->
                </li>
                <li>
                  <h3>Payment </h3>
                </li>
              </ul>
          </v-col>
          <v-col cols="12" sm="6" class="registerForm__summary">
              <h3 class="registerForm__summaryTitle">Order Summary</h3>
              <table class="registerForm__table" style="width: 100%;">
                <tr>
                  <th align="left">Service Name</th>
                  <th align="right">Service Price</th>
                </tr>
                <tr v-for="(item) in cartLineItems" :key="item.details ? item.details.id : item.product.id">
                  <td align="left" v-html="item.product.service_name"></td>
                  <td align="right">
                    <del v-if="item.product.compare_at_price">${{ item.product.compare_at_price }}</del>
                    <ins>${{ item.product.price }}</ins>
                  </td>
                </tr>
              </table>
              <h3 class="registerForm__summaryTotal">
                <span>Total</span>
                <span class="price" v-html="total"></span>
              </h3>
          </v-col>
        </v-row>
      </div>
    </div>
    <div key="choosePackage" v-if="showStep == 2">
      <QuestionFormInformation :visibleUploader="requiresFileUpload" @onSubmit="onCustomerFormSubmit" />
    </div>
    <div key="appointment" v-if="showStep == 3 && makePlansServiceID">
      <div class="maxContainer">
        <appointment-picker :service-id="makePlansServiceID" @select="appointmentSelect" />
      </div>
    </div>
    <div key="Confirmation" v-if="showStep == 4">
      <div>
        <v-layout row align-center justify-center>
          <v-layout column align-center class="spacerTop">
            <v-progress-circular :size="100" color="primary" indeterminate class="mt-5"></v-progress-circular>
            <span class=" mt-2 subheading font-weight-regular grey--text">Loading...</span>
          </v-layout>
        </v-layout>
      </div>
      <!-- <button @click="gotoCheckout">Confirmation Step</button> -->
    </div>
  </transition-group>
</template>
<script>
import QuestionFormInformation from "@/components/Services/ServicesQuestions/QuestionFormInformation";
import AppointmentPicker from './AppointmentPicker'
import ServiceItemMixin from './service-item-mixins'
import { mapState, mapActions } from 'vuex'
import ServiceAPI from '@/lib/serviceApi'

export default {
  mixins: [ServiceItemMixin],
  data() {
    return {
      showStep: 1,
      filledForm: {},
      selectedType: null,
      products : [],
      allElements : '',
      getFiltered : '',
      appointmentSlot: null,
      order: null,
      quizResponse: null,
    };
  },
  components: {
    QuestionFormInformation,
    AppointmentPicker,
    // ConfirmationPage,
  },
  watch: {
    showStep () {
      if (this.showStep === 3 && !this.makePlansServiceID) {
        this.showNextStep()
      }

      if (this.showStep === 4) {
        this.createOrder()
      }
    }
  },
  methods: {
    gotoPrevStep () {
      this.showStep = this.showStep - 1;
    },
    gotoCheckout (order) {
      const stripe = Stripe(this.stripeKey)
      stripe.redirectToCheckout({
        sessionId: order.checkout.id
      })
    },
    showNextStep () {
      this.showStep = this.showStep + 1;
    },
    goToBackStep () {
      window.scrollTo(0, 0);
      this.showStep = this.showStep - 1;
    },
    goToNextStep (data,event) {
      this.selectedType = data
      window.scrollTo(0, 0);
      this.showNextStep()
    },
    onCustomerFormSubmit (data) {
      this.quizResponse = data
      this.showNextStep()
    },
    appointmentSelect (appointmentSlot) {
      this.appointmentSlot = appointmentSlot
      this.showStep = 4
    },
    async createOrder () {
      const order = await ServiceAPI.post('orders', {
        "customer_id": this.user.uid,
        "quizRef": this.quizResponse,
        "items": this.cartItems.map((item) => {
          return { price: item, quantity: 1 }
        })
      })
      this.order = order.data

      if (this.makePlansServiceID) {
        await ServiceAPI.post(`orders/${this.order.id}/appointment`, {
          "from": this.appointmentSlot.timestamp,
          "to": this.appointmentSlot.timestamp_end,
          "serviceID": this.makePlansServiceID
        })
      }

      const checkout = await ServiceAPI.post(`orders/${this.order.id}/checkout`)
      this.gotoCheckout(checkout.data)
    }
  },
  created () {
    if (!this.cartItems.length) {
      this.$router.replace(`/services`)
    }
  },
  unmount () {
    this.showStep = 0;
  }
}
</script>
<style scoped>
/* .Services__progressBar {
  max-width: 700px;
  margin: 40px auto 80px;
  display: none;
}
.Services__progressBarList {
  list-style: none;
  padding: 0;
  display: flex;
  justify-content: center;
}

.Services__progressBarListItem {
  position: relative;
  background-color: #465973;
  color: #fff;
  border: 2px solid #465973;
  border-radius: 44px;
  min-width: 44px;
  padding: 8px 16px;
  transition: all 0.3s ease-in;
}

.Services__progressBarListItem::after {
  content: '';
  position: absolute;
  top: 50%;
  left: 100%;
  width: 100px;
  display: block;
  background-color: #465973;
  height: 2px;
  margin-top: -1px;
}
.Services__progressBarListItem:last-child::after {
  display: none;
}
.Services__progressBarListItem .text {
  font-size: 14px;
}

.Services__progressBarListItem.active {
  background-color: #191340;
  color: white;
}

@media (min-width: 960px) {
  .Services__progressBar {
    display: block;
  }
} */

.registerForm {
  max-width: 900px;
  margin: 100px auto 0;
}

.registerForm__summary {
  box-shadow: 0 10px 30px -10px rgba(0,0,0,.19);
  padding: 20px;
}

.registerForm__list {
  counter-reset: number;
  list-style-type: none;
  padding: 0 30px 0 30px;
}

.registerForm__list li {
  padding: 10px 0;
  position: relative;
  display: flex;
  justify-content: space-between;
}

.registerForm__list li::before {
  counter-increment: number;
  content: counter(number)"\a0";
  position: absolute;
  left: -20px;
  top: 8px;
  font-size: 24px;
  font-weight: bold;
}

.registerForm__list li + li {
  border-top: 1px solid #000;
}
.registerForm__list li p {
  margin-bottom: 0;
}

.registerForm__summaryTitle {
  border-bottom: 1px solid #000;
  padding-bottom: 10px;
  margin-bottom: 10px;
  padding-left: 15px;
  padding-top: 15px;
  padding-right: 15px;
}

.registerForm__table {
  padding: 0 15px;
  width: 100%;
}

dl dt {
  font-weight: bold;
}
dl dd {
  text-align: right;
}
dl dd + dt {
  margin-top: 10px;
}

.registerForm__summaryTotal {
  justify-content: space-between;
  background-color: #191340;
  color: #fff;
  margin-top: 16px;
  padding: 10px 16px;
  display: flex;
}
.spacerTop {
  padding-top: 100px;
}
</style>



// WEBPACK FOOTER //
// src/components/Services/ServicesPurchase.vue